import {
    CmsMediaFileData,
    TLinkToCategoryPageData,
    TLinkToPageData,
    TLinkToSystemPageData,
} from '@renderer-ui-library/molecules';
import { BlockType } from 'blocks/BlockType';
import { IBaseBlockData } from 'blocks/IBaseBlockData';

export enum CardTrackingType {
    HowToBuyOnline = 'HowToBuyOnline',
    WithAdviceToMachine = 'WithAdviceToMachine',
    SafetyInspection = 'SafetyInspection',
    SaveWallet = 'SaveWallet',
    Delivery = 'Delivery',
    SecuredBeyondPurchase = 'SecuredBeyondPurchase',
    HighQuality = 'HighQuality',
    AuctionTransport = 'AuctionTransport',
    NoFees = 'NoFees',
}

interface Card {
    headline: string;
    description: string;
    systemPage: null | TLinkToSystemPageData;
    page: null | TLinkToPageData;
    machineCategoryPage: null | TLinkToCategoryPageData;
    image: CmsMediaFileData;
    trackingCardType: CardTrackingType;
}

export interface ICardBannerBlockData extends IBaseBlockData {
    type: BlockType.CardBannerBlock;
    headline: string;
    image: CmsMediaFileData;
    cards: Card[];
}
